export const DEFAULT_UPLOAD_TIMEFRAME = "all";

export const UPLOAD_TIMEFRAME_OPTIONS = [
  { value: "all", label: "All" },
  { value: "year", label: "Year" },
  { value: "month", label: "Month" },
  { value: "week", label: "Week" },
  { value: "day", label: "Day" },
];

export const UPLOAD_TIMEFRAME_META_SUFFIX = {
  year: " this year",
  month: " this month",
  week: " this week",
  day: " today",
};

export const PATTERN_FILTER_MIN_VIDEOS_FOR_MONTH_TIMEFRAME = 500;
export const PATTERN_FILTER_RECENT_SYNC_DAYS = 7;
/** Auto-enable "more than 1 video" only when this many patterns have count >= 2. */
export const PATTERN_FILTER_MIN_MULTI_VIDEO_PATTERNS = 10;

const RECENT_SYNC_MS = PATTERN_FILTER_RECENT_SYNC_DAYS * 24 * 60 * 60 * 1000;

export function shouldDefaultFilterMoreThanOneVideo(patterns) {
  const multiCount = (patterns || []).filter((p) => {
    const name = String(p.name ?? p.id ?? "");
    if (name.includes("~")) return false;
    return (p.stats?.video_count ?? 0) >= 2;
  }).length;
  return multiCount >= PATTERN_FILTER_MIN_MULTI_VIDEO_PATTERNS;
}

export function getDefaultPatternFilters(audience) {
  const videoCount = audience?.high_fit_video_count ?? 0;
  let uploadTimeframe = DEFAULT_UPLOAD_TIMEFRAME;

  if (videoCount > PATTERN_FILTER_MIN_VIDEOS_FOR_MONTH_TIMEFRAME) {
    if (!audience?.videos_synced_at) {
      uploadTimeframe = "month";
    } else {
      const syncedAt = new Date(audience.videos_synced_at);
      if (!Number.isNaN(syncedAt.getTime()) && Date.now() - syncedAt.getTime() <= RECENT_SYNC_MS) {
        uploadTimeframe = "month";
      }
    }
  }

  return { uploadTimeframe };
}
